<template>
<div id="menuArea">
  <input type="checkbox" id="menuToggle" v-model="mobileMenu"></input>

<label for="menuToggle" class="menuOpen" >
  <div class="open"></div>
</label>

<div class="menu menuEffects">
  <div class="menuContent" @click="mobileMenu = !mobileMenu">
      <router-link to="/" exact>home</router-link>
      <router-link to="/projekty">projekty</router-link>
      <router-link to="/oferta">oferta</router-link>
      <router-link to="/pracownia">pracownia</router-link>
      <router-link to="/kontakt">kontakt</router-link>
     <div class="social-icons">
        <a
          href="https://www.instagram.com/annamillerarchitekci"
          target="_blank"
          class="social-icon"
          rel="nofollow"
        >
          <div class="instagram-logo invertedIcon" ></div>
        </a>
        <a
          href="https://pl.linkedin.com/in/annamillerarchitekt"
          target="_blank"
          class="social-icon"
          rel="nofollow"
        >
          <div class="linkedin-logo invertedIcon" ></div>
        </a>
      </div>
  </div>
</div>
</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
let Config = require("../app.config.js");
const fetchInitialData = store => {
  return store.dispatch(`menu/getMenu`, "menu_main");
};
export default {
  name: "app-mobile-header",
  data: () => {
    return {
      mobileMenu: false,
      isMenuActive: false,
      ayContrast: false,
      siteName: ""
    };
  },
  prefetch: fetchInitialData,
  computed: {
    ...mapGetters("menu", ["menuItems", "testIt"])
  },
  methods: {
    changeUrl(url) {
      return url.replace(Config.wpDomain, "/");
    },
    ...mapActions("menu", {
      getMenu: "getMenu"
    }),
    toggleMenu() {
      this.isActive = !this.isActive;
    },
    closeMenu() {
      this.isMenuActive = false;
    },
    relativePath(url) {
      url = url.replace("https://", "");
      var domain = url.split("/")[0];
      return url.replace(domain, "");
    },
    loadData() {
      fetchInitialData(this.$store);
    }
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
#menuArea{
    display:none;
    right:10px;
    position:fixed;
    z-index: 99;
    @media (max-width: 768px) {
        
    display:block;
    }
}

input {
  display: none;
}
.redBackground {
    .open ,
    .open:before ,
    .open:after {
    background-color: #fff;
    }
}
.open {
  background-color: #b61e3e;
  width: 100%;
  height: 1px;
  display: block;
  cursor: pointer;
  position: relative;
  top: 8px;
}

.open:before {
  content: "";
  background-color: #b61e3e;
  width: 100%;
  height: 1px;
  display: block;
  position: relative;
  top: -18px;
  transform: rotate(0deg);
  transition: all 0.3s ease;
}

.open:after {
  content: "";
  background-color: #b61e3e;
  width: 100%;
  height: 1px;
  display: block;
  position: relative;
  top: 18px;
  transform: rotate(0deg);
  transition: all 0.3s ease;
}

.menuOpen {
    width: 60px;
    height: 60px;
    display: block;
    cursor: pointer;
    float: right;
    margin: 47px 20px 0 0;
}
.menu {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background:#b61e3e;
}

.menu .menuOpen {
  width: 30px;
  height: 30px;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 100;
  background-size: 100%;
  cursor: pointer;
}

.menu .menuContent {
    display:flex;
    flex-direction: column;
    z-index: 99;
  position: relative;
  top: 50%;
  font-size: 27px;
  text-align: center;
  padding-bottom: 20px;
  margin-top: -170px;
  a{
      padding:15px;
      color:#fff;
      &.social-icon{
        margin-top:15px;
        padding: px;
    display: inline-block;
      }
      &:hover{
        transition: all 0.5s;
          opacity:0.8;
          text-decoration:none;
      }
  }
}


.menuEffects {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s, visibility 0.5s;
}

.menuEffects ul {
  transform: translateY(0%);
  transition: all 0.5s;
}

#menuToggle:checked ~ .menuEffects {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.5s;
}

#menuToggle:checked ~ .menuEffects ul {
  opacity: 1;
}

#menuToggle:checked ~ .menuOpen .open {
  background-color: transparent;
  height:30px;
  position:relative;
  z-index: 2;
}

#menuToggle:checked ~ .menuOpen .open:before {
  content: "";
  background-color: white;
  transform: rotate(45deg);
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

#menuToggle:checked ~ .menuOpen .open:after {
  content: "";
  background-color: white;
  transform: rotate(-45deg);
  position: relative;
  top: 0;
  right: 0;
  z-index: 1;
}

#menuToggle:not(:checked) ~ .menuEffects ul {
  transform: translateY(-30%);
}
</style>
